import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Box,
    Typography,
    FormHelperText,
    Autocomplete,
    Grid,
    Alert,
} from '@mui/material';
import { DatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import request from '../../utils/request';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setDataSuccess } from 'src/features/staticDataSlice';
import { updateEndorsementFormData, updateEndorsementScreenNumber } from 'src/features/rfqDataSlice';
import { checkRFQEditPermission } from 'src/utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import moment from 'moment';

const CreateEdit = ({ onClose, setShowSnackBarAlert, fetchData }) => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const policyId = searchParams.get('policyid');
    const [loader, setLoader] = React.useState(false);
    const [endoresementSubTypeData, setEndoresementSubTypeData] = useState<any>([]);
    const [selectedEndoresementSubTypeData, setSelectedEndoresementSubTypeData] = useState<any>([]);
    const [policyListDataArr, setPolicyListDataArr] = useState<any>([]);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [hasCreatePermission, setCreatePermission] = useState(false);
    const [createPermissionChkLoading, setCreatePermissionChkLoading] = useState(true);



    // useEffect(() => {
    //     if (policyId) {
    //         formik.setFieldValue('policyId', Number(policyId));
    //     }
    // }, [policyId]);
    useEffect(() => {
        if (policyListDataArr.length > 0) {
            let selectedPolicy = policyListDataArr.find((item) => item.id == policyId)
            if (selectedPolicy) {
                formik.setFieldValue('policyId', Number(policyId));
            }
            setSelectedPolicy(selectedPolicy);
        }

    }, [policyListDataArr])

    useEffect(() => {
        if (selectedPolicy?.rfq?.createdBy)
            handleEditPermissionCheck(selectedPolicy?.rfq?.createdBy, selectedPolicy?.rfq)
    }, [selectedPolicy])



    const EndoresementSchema = Yup.object().shape({
        policyId: Yup.string().typeError('Policy Number is required').required('Policy Number is required'),
        type: Yup.string().required('Endorsement Type is required'),
        subType: Yup.string().when('type', {
            is: (val) => val !== 'Both1',
            then: Yup.string().required('Endorsement Sub Type is required'),
            otherwise: Yup.string().notRequired(),
        }),
        extended_policy: Yup.date()
            .nullable()
            .when('type', {
                is: 'Extension-Endorsement',
                then: (schema) =>
                    schema.required('Extended Policy Date is required'),
                otherwise: (schema) => schema.notRequired(),
            }),
        cancellation_Endorsement: Yup.date()
            .nullable()
            .when('type', {
                is: 'Cancellation-Endorsement',
                then: (schema) =>
                    schema.required('Policy Cancellation Date is required'),
                otherwise: (schema) => schema.notRequired(),
            }),
        // description: Yup.string().required('Subject Matter of Endorsement is required'),
    });


    const formik = useFormik({
        initialValues: {
            policyId,
            type: '',
            subType: '',
            description: '',
            extended_policy: '',
            cancellation_Endorsement: ''
        },
        validationSchema: EndoresementSchema,
        onSubmit: (values) => {

            // if (selectedPolicy?.pendingEndorsements.length > 0) {
            //     setShowSnackBarAlert({
            //         status: true,
            //         type: 'error',
            //         message: 'An open endorsement already exists for this policy.'
            //     })
            //     return;
            // }


            dispatch(updateEndorsementFormData({
                policyId: values.policyId,
                type: values.type,
                subType: values.subType,
                description: values.description,
                customerData: null,
                dynamicFormData: null,
                secondDynamicFormData: null,
                thirdDynamicFormData: null,
                sumInsuredSectionData: [],
                riskDescription: null,
                suggestedDeductible: null,
                hypothetical_details: [],
                warrantiesExclusions: null,
                extended_policy: values.extended_policy
                    ? moment(values.extended_policy).format('DD-MM-YYYY')
                    : null,
                cancellation_Endorsement: values.cancellation_Endorsement
                    ? moment(values.cancellation_Endorsement).format('DD-MM-YYYY')
                    : null

            }))

            dispatch(updateEndorsementScreenNumber(values.type == 'Extension-Endorsement' || values.type == 'Cancellation-Endorsement' ? 3 : 1))

            onClose(true)


            // setLoader(true);

            // const URL = 'endorsement/createEndoresement';
            // request({
            //     url: URL,
            //     method: 'POST',
            //     data: values
            // }).then((response) => {
            //         if (response.status) {
            //             setLoader(false);
            //             setShowSnackBarAlert({
            //                 status: true,
            //                 type: 'success',
            //                 message: response['message']
            //             });
            //             fetchData();
            //             onClose();
            //         } else {
            //             setLoader(false);
            //             setShowSnackBarAlert({
            //                 status: true,
            //                 type: 'error',
            //                 message: response['message']
            //             });
            //         }
            //     }) .catch(function (err) {
            //         setShowSnackBarAlert({
            //             status: true,
            //             type: 'error',
            //             message: err.message
            //         });
            //         setLoader(false);
            //     });
        }
    });

    const extensionDays = React.useMemo(() => {
        if (!formik.values.extended_policy || !selectedPolicy?.policyEndDate) return null;

        const start = moment(selectedPolicy.policyEndDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).startOf('day');
        const end = moment(formik.values.extended_policy).startOf('day');

        return end.diff(start, 'days');
    }, [formik.values.extended_policy, selectedPolicy?.policyEndDate]);



    useEffect(() => {
        getendoresementSubTypeData();
        policyListData();
    }, []);

    useEffect(() => {
        if (formik.values?.policyId) {
            getendoresementSubTypeData();
        }

    }, [formik.values?.policyId])




    const getendoresementSubTypeData = async () => {
        setLoader(true);
        setEndoresementSubTypeData([]);
        request({
            url: 'endorsement/getEndoresementSubTypes',
            method: 'post',
            data: {

                orderColumn: 'id',
                orderDirection: 'DESC',
                offset: 0,
                limit: 500,
                policyId: parseInt(policyId ? policyId : formik.values?.policyId),
                status: true
            }
        }).then(
            (response) => {
                setLoader(false);
                setEndoresementSubTypeData(response['rows']);
                setSelectedEndoresementSubTypeData(response['rows'])

            },
            (error) => {
                console.log(error);
                setLoader(false);
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message: 'Something Went wrong'
                });
            }
        );
    };

    const policyListData = () => {
        request({
            url: 'insurancePolicy/getPolicyListForEndorsement',
            method: 'post',
            data: {

                orderColumn: 'id',
                orderDirection: 'DESC',
                offset: 0,
                limit: 5000,
                // status: 'Live',
            }
        }).then(
            (response) => {
                setPolicyListDataArr(response['rows']);

            },
            (error) => {
                console.log(error);
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message: 'Something Went wrong'
                });
            }
        );
    }

    const handleEditPermissionCheck = async (createdBy, rfq) => {
        const userDatas = JSON.parse(localStorage.getItem('userDatas'));
        const loggedInUserId = userDatas?.userData?.id;


        try {
            const response = await checkRFQEditPermission(
                'Endorsements',
                'create',
                createdBy,
                rfq
            );
            if (response?.data?.permission) {
                setCreatePermission(true);
                setCreatePermissionChkLoading(false)
            } else {
                setCreatePermission(false);
                setCreatePermissionChkLoading(false)
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message: 'Create access denied'
                });
            }
        } catch (error) {
            setCreatePermissionChkLoading(false)
            console.error('Edit permission check failed:', error);
            setShowSnackBarAlert({
                status: true,
                type: 'error',
                message: 'Something went wrong while checking permissions'
            });
        }
    };

    return (
        <Dialog open={true} onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
                onClose(false);
            }
        }} maxWidth="sm" fullWidth disableEscapeKeyDown>
            <DialogTitle>Create Endorsement</DialogTitle>
            <form onSubmit={formik.handleSubmit}>
                <DialogContent>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Autocomplete
                            disabled={policyId ? true : false}
                            options={policyListDataArr}
                            getOptionLabel={(option) => option.policyNumber || ''}
                            size="small"
                            value={
                                policyListDataArr.find(
                                    (item) => item.id === formik.values.policyId
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                formik.setFieldValue('policyId', newValue ? newValue.id : null);
                                setSelectedPolicy(newValue);
                                getendoresementSubTypeData();
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            {'Policy Number'} {' '}
                                            <Typography component="span" sx={{ color: 'red' }}>
                                                *
                                            </Typography>
                                        </>

                                    }
                                    name="policyId"
                                    error={formik.touched.policyId && Boolean(formik.errors.policyId)}
                                    helperText={formik.touched.policyId && formik.errors.policyId}
                                />
                            )}
                        />

                        {/* Endorsement Type */}
                        <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            style={{ background: '#fff' }}
                        >
                            <InputLabel id="endorsement-type-label"
                                style={{ background: '#fff', paddingLeft: '2px', paddingRight: '2px' }}
                                sx={{
                                    color: formik.touched.type && formik.errors.type ? 'red' : '', // Change placeholder color
                                }}

                            >
                                Endorsement Type{' '}
                                <Typography component="span" sx={{ color: 'red' }}>
                                    *
                                </Typography>
                            </InputLabel>
                            <Select
                                labelId="financial-select-label"
                                id="financial-select"
                                name="type"
                                disabled={formik.values.policyId == null}
                                value={formik.values.type}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    formik.setFieldValue("type", value);

                                    if (value === 'Both') {
                                        setSelectedEndoresementSubTypeData(endoresementSubTypeData);
                                    } else if (value === 'Extension-Endorsement' || value === 'Cancellation-Endorsement') {
                                        // treat as Financial
                                        setSelectedEndoresementSubTypeData(
                                            endoresementSubTypeData.filter(
                                                (item) => item.type === 'Financial'
                                            )
                                        );
                                    } else {
                                        setSelectedEndoresementSubTypeData(
                                            endoresementSubTypeData.filter(
                                                (item) => item.type === value
                                            )
                                        );
                                    }

                                    formik.setFieldValue('subType', '');
                                }}
                                label="Endorsement Type"
                                error={
                                    formik.touched.type &&
                                    Boolean(formik.errors.type)
                                }
                            >
                                <MenuItem value="Financial">Financial</MenuItem>
                                <MenuItem value="Non-Financial">Non-Financial</MenuItem>
                                <MenuItem value="Extension-Endorsement">Extension-Endorsement</MenuItem>
                                <MenuItem value="Cancellation-Endorsement">Cancellation-Endorsement</MenuItem>
                                <MenuItem value="Both">Both</MenuItem>
                            </Select>
                            {formik.touched.type && formik.errors.type && (
                                <FormHelperText sx={{ color: 'red' }}>{formik.errors.type}</FormHelperText>
                            )}
                        </FormControl>

                        {/* Endorsement Sub Type */}
                        {<>
                            <FormControl
                                fullWidth
                                variant="outlined"
                                size="small"
                                style={{ background: '#fff' }}
                            >
                                <InputLabel
                                    id="endorsement-type-label"
                                    style={{ background: '#fff', paddingLeft: '2px', paddingRight: '2px' }}
                                    sx={{
                                        color:
                                            formik.touched.subType && formik.errors.subType ? 'red' : '',
                                    }}
                                >
                                    Endorsement Sub Type{' '}
                                    <Typography component="span" sx={{ color: 'red' }}>
                                        *
                                    </Typography>
                                </InputLabel>

                                <Select
                                    labelId="financial-select-label"
                                    id="financial-select"
                                    name="subType"
                                    value={formik.values.subType}
                                    onChange={formik.handleChange}
                                    label="Endorsement Sub Type"
                                    error={formik.touched.subType && Boolean(formik.errors.subType)}
                                    disabled={!formik.values.type || formik.values.policyId == null}
                                >
                                    {selectedEndoresementSubTypeData && selectedEndoresementSubTypeData.length > 0 ? (
                                        selectedEndoresementSubTypeData.map((item, index) => (
                                            <MenuItem value={item.id} key={index}>
                                                {item?.name}
                                                {formik.values.type === 'Both' && (
                                                    <span style={{ marginLeft: 4 }}>({item.type})</span>
                                                )}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem
                                            value=""
                                            onClick={(e) => e.stopPropagation()} // ✅ prevents selection
                                            sx={{
                                                color: '#000', // normal text color
                                                pointerEvents: 'none', // blocks interaction
                                                opacity: 1, // ensures not dimmed
                                            }}
                                        >
                                            No Data Found
                                        </MenuItem>
                                    )}
                                </Select>


                                {formik.touched.subType && formik.errors.subType && (
                                    <FormHelperText sx={{ color: 'red' }}>
                                        {formik.errors.subType}
                                    </FormHelperText>
                                )}
                            </FormControl>


                        </>}

                        {formik.values.type == 'Extension-Endorsement' && <LocalizationProvider dateAdapter={AdapterDateFns}>

                            <DatePicker
                                views={['year', 'month', 'day']}
                                inputFormat="dd-MM-yyyy"
                                label={<> {'Extended Policy Date'}
                                    <Typography component="span" sx={{ color: 'red' }}>
                                        {' '} *
                                    </Typography>
                                </>}
                                minDate={
                                    selectedPolicy?.policyEndDate
                                        ? moment(selectedPolicy.policyEndDate, ['YYYY-MM-DD', 'DD-MM-YYYY'])
                                            .add(1, 'day')
                                            .toDate()
                                        : null
                                }

                                defaultCalendarMonth={
                                    selectedPolicy?.policyEndDate
                                        ? moment(selectedPolicy.policyEndDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).toDate()
                                        : null
                                }
                                value={formik.values.extended_policy}
                                onChange={(newValue) => {
                                    formik.setFieldValue('extended_policy', newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        error={
                                            formik.touched.extended_policy &&
                                            Boolean(formik.errors.extended_policy)
                                        }
                                        helperText={
                                            formik.touched.extended_policy &&
                                            formik.errors.extended_policy
                                        }
                                        onBlur={formik.handleBlur}
                                        name="extended_policy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                )}
                            />
                        </LocalizationProvider>}
                        {extensionDays !== null && formik.values.type == 'Extension-Endorsement' && (
                            <Typography
                                sx={{
                                    color: extensionDays < 0 ? 'error.main' : 'success.main',
                                    fontWeight: 500,
                                    mt: 0
                                }}
                            >
                                {extensionDays === 0
                                    ? 'No change in policy duration'
                                    : extensionDays < 0
                                        ? `Reduced by ${Math.abs(extensionDays)} days`
                                        : `Extended by ${extensionDays} days`}
                            </Typography>
                        )}
                        {formik.values.type == 'Cancellation-Endorsement' && <LocalizationProvider dateAdapter={AdapterDateFns}>

                            <DatePicker
                                views={['year', 'month', 'day']}
                                inputFormat="dd-MM-yyyy"
                                label={<> {'Policy Cancellation Date'}
                                    <Typography component="span" sx={{ color: 'red' }}>
                                        {' '} *
                                    </Typography>
                                </>}

                                minDate={
                                    selectedPolicy?.policyStartDate
                                        ? moment(selectedPolicy.policyStartDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).toDate()
                                        : null
                                }

                                // defaultCalendarMonth={
                                //     selectedPolicy?.cancellation_Endorsement
                                //         ? moment(selectedPolicy.cancellation_Endorsement, ['YYYY-MM-DD', 'DD-MM-YYYY']).toDate()
                                //         : null
                                // }
                                value={formik.values.cancellation_Endorsement}
                                onChange={(newValue) => {
                                    formik.setFieldValue('cancellation_Endorsement', newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        error={
                                            formik.touched.cancellation_Endorsement &&
                                            Boolean(formik.errors.cancellation_Endorsement)
                                        }
                                        helperText={
                                            formik.touched.cancellation_Endorsement &&
                                            formik.errors.cancellation_Endorsement
                                        }
                                        onBlur={formik.handleBlur}
                                        name="cancellation_Endorsement"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                )}
                            />
                        </LocalizationProvider>}

                        {formik.values.type == 'Cancellation-Endorsement' && <TextField
                            size={'small'}
                            label={
                                <>
                                    Cancellation Reason {' '}
                                    {/* <Typography component="span" sx={{ color: 'red' }}>
                                        *
                                    </Typography> */}
                                </>
                            }
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            fullWidth
                            multiline
                            rows={4}
                            name='description'
                            error={
                                formik.touched.description &&
                                Boolean(formik.errors.description)
                            }
                            helperText={
                                formik.touched.description &&
                                formik.errors.description
                            }
                        />}

                    </Box>
                </DialogContent>
                {!hasCreatePermission && !createPermissionChkLoading && <>
                    <Grid item xs={12}>
                        <div
                            style={{ position: 'relative' }}
                            className="warningCenter"
                        >
                            <Alert severity="warning" style={{ minHeight: '50px' }}>
                                You don't have permission to create this Endorsement
                            </Alert>
                        </div>
                    </Grid>
                </>}

                <DialogActions>
                    <LoadingButton
                        sx={{ mt: { xs: 2, md: 0 } }}
                        loading={loader}
                        variant="contained"
                        type="submit"
                        disabled={!hasCreatePermission}
                    >
                        Proceed
                    </LoadingButton>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="error"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CreateEdit;